import colors from './colors';

export const baseSansStack =
  "Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

export const baseMonoStack =
  "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace";

export type textVariantKeys =
  | 'heading1'
  | 'heading2'
  | 'heading3'
  | 'body1'
  | 'body1a'
  | 'body2'
  | 'body3'
  | 'subheading'
  | 'mono';

type textDescriptionObject = {
  description: string;
  spec: string;
  uses: string;
};

type textDescriptionsType = Record<textVariantKeys, textDescriptionObject>;

export const textDescriptions: textDescriptionsType = {
  heading1: {
    description: 'Heading 1',
    spec: '32 / 2',
    uses: 'Page title; Primary Heading',
  },
  heading2: {
    description: 'Heading 2',
    spec: '16 / 2',
    uses: 'Secondary page headiing',
  },
  heading3: {
    description: 'Heading 3',
    spec: '16 / 1.5',
    uses: 'Sidebar card title',
  },

  body1: {
    description: 'Body 1',
    spec: '16 / 1.5',
    uses: 'Default Body',
  },
  body1a: {
    description: 'Body 1a',
    spec: '16 / 1.25',
    uses: 'Gridded data; Defualt body w/ tighter line space',
  },
  body2: {
    description: 'Body 2',
    spec: '14 / 1.1428 (16)',
    uses: 'Interactive elements; Navlink, userlink, button, form fields',
  },
  body3: {
    description: 'Body 3',
    spec: '?',
    uses: '?',
  },
  subheading: {
    description: 'Subheading',
    spec: '12 / 1.333',
    uses: 'Gridded data labels',
  },
  mono: {
    description: 'Mono',
    spec: '12 / 1.5',
    uses: 'Debug / Docs',
  },
};

const textVariants = {
  heading1: {
    fontFamily: 'inherit',
    fontWeight: 'heading',
    fontSize: [5], // 32
    lineHeight: 'scale.4', // 2
  },
  heading2: {
    fontFamily: 'inherit',
    fontWeight: 'heading',
    fontSize: [4], // 24
    lineHeight: 'scale.3', // 2
  },
  heading3: {
    fontFamily: 'inherit',
    fontWeight: 'heading',
    fontSize: [2], // 16
    lineHeight: 'scale.3', // 1.5
  },
  body1: {
    fontFamily: 'inherit',
    fontWeight: 'body',
    fontSize: [2], // 16
    lineHeight: 'scale.3', // 1.5
  },
  body1a: {
    fontFamily: 'inherit',
    fontWeight: 'body',
    fontSize: [2], // 16
    lineHeight: 'scale.1', // 1.25
  },
  body2: {
    fontFamily: 'inherit',
    fontWeight: 'body',
    fontSize: [1], // 14
    lineHeight: 'interactive', // 1.142857143
  },
  body3: {
    fontFamily: 'inherit',
    fontWeight: 'body',
    fontSize: [0], // 12
    lineHeight: 'interactive', // 1.142857143
  },
  bodyTimeline: {
    fontFamily: 'root',
    fontSize: [0], // 12
    fontStyle: 'normal',
    lineHeight: 'scale.2', // 16
  },
  bodyTimelineItalic: {
    fontFamily: 'root',
    fontSize: [0], // 12
    fontStyle: 'italic',
    lineHeight: 'scale.2', // 16
  },
  subheading: {
    fontFamily: 'inherit',
    fontWeight: 'heading',
    fontSize: [0], // 12
    lineHeight: 'scale.2', // 1.333
  },
  validation: {
    fontFamily: 'inherit',
    fontWeight: 'body',
    fontSize: '11px', // 12
    lineHeight: 'scale.2', // 1.333
    color: colors.statusError,
  },
  mono: {
    fontFamily: 'monospace',
    fontSize: [0],
    fontWeight: 'heading',
  },
};

export default textVariants;
